export enum QuoteState {
  Complete = 'complete',
  Incomplete = 'incomplete',
  Expired = 'expired',
  Mixed = 'mixed', // NOTE: Never set on quotes, used only for the filtered tab as table state
}
